if (!customElements.get('variant-preorder-block')) {
    class PreorderBlock extends HTMLElement {
        constructor() {
            super();
            this.variantSpecs = {};
            this.init();
        }

        init() {
            productVariants.forEach(variant => {
                const { id: variantId, preorderDate} = variant;

                this.variantSpecs[variantId] = { preorderDate };
            });

            this.checkUrlVariant();

            document.addEventListener('on:variant:change', (evt) => {
                this.togglePreorderBlock(evt.detail?.variant?.id);
            });
        }
      
        /**
         * Checks the URL for ?variant= and applies the same logic as on variant change.
         */
        checkUrlVariant() {
            const preorderBlock = document.querySelector(".preorder-block");
            if (!preorderBlock) return;
        
            const searchParams = new URLSearchParams(window.location.search);
            const urlVariantId = searchParams.get('variant');
          
            if (urlVariantId) {
                this.togglePreorderBlock(urlVariantId);
            } else {
                if (productVariants.length > 1) {
                    preorderBlock.style.display = 'none';
                } else if (productVariants.length === 1) {
                    const variantId = productVariants[0].id;
                    this.togglePreorderBlock(variantId);
                }
            }
        }
      
        /**
         * Shows or hides the preorder block based on the variant's preorder date.
         */
        togglePreorderBlock(variantId) {
            const preorderBlock = document.querySelector(".preorder-block");
            if (!preorderBlock) return;

            const { preorderDate } = this.variantSpecs[variantId] || {};

            if (preorderDate) {
                const startDate = new Date(preorderDate);
                startDate.setDate(startDate.getDate() - 2);

                preorderBlock.style.display = (Date.now() < startDate.getTime()) ? 'block' : 'none';
                preorderBlock.querySelector(".preorder-block__date").textContent = preorderDate;
            } else {
                preorderBlock.style.display = 'none';
            }
        }
    }

    customElements.define('variant-preorder-block', PreorderBlock);
}
